/**
 * weiboOperationBtnsModule
 * description: 微博渠道下操作按钮
 * author: Qian.qianchen 2019-03-21
 */
'use strict';
angular.module('weiboOperationBtnsModule', []).directive('weiboOperationBtns', [
    'modalDialog',
    'trsHttpService',
    'sensitiveWordCheckService',
    'editingCenterWeiBoService',
    function(modalDialog, trsHttpService, sensitiveWordCheckService, editingCenterWeiBoService) {
        return {
            restrict: 'E',
            replace: false,
            templateUrl: './editingCenter/iWo/fusionPending/directive/weiboOperationBtns/weiboOperationBtns_tpl.html',
            scope: {
                selectedArr: '=',
                callback: '&',
            },
            link: function($scope, iElement, attrs) {

                /**
                 * [timeFormat description] 日期day+1处理
                 * @param  {[String]} timeStr [description]日期字符串
                 * @return {[type]}         [description]
                 */
                function timeFormat(timeStr) {
                    if (angular.isDefined(timeStr) && timeStr != '') {
                        var date = timeStr.replace(/-/g, '/');
                        var timestamp = new Date(date).getTime();
                        timestamp = timestamp + 24 * 60 * 60 * 1000;
                        var d = new Date(timestamp);
                        return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
                    } else {
                        return '';
                    }
                }

                /** *微博操作按钮方法 start***/
                /**
                 * [trialForWeibo description] 微博送审
                 * @param  {[object]} item [description] 需要送审的微博对象
                 * @return {[type]}      [description]
                 */
                $scope.trialForWeibo = function() {
                    modalDialog.alertType('送审', '是否确认送审此微博', 'ask', true, function() {
                        let params = {
                            ObjectIds: $scope.selectedArr
                                .map(function(item) {
                                    return item.SCMMICROCONTENTID;
                                })
                                .join(','),
                        };
                        $scope.$parent.$parent.loadingPromise = editingCenterWeiBoService.trail(params).then(
                            (data) => {
                                modalDialog.alertType('送审成功', '', 'success', false);
                                $scope.callback();
                            },
                            function(data) {
                                modalDialog.alertType(data.TITLE, data.REPORTS.DETAIL, 'error', false);
                            }
                        );
                    });
                };

                /**
                 * [directSignForWeibo description] 直接签发
                 * @return {[type]}      [description]
                 */
                $scope.directSignForWeibo = function() {
                    editingCenterWeiBoService.directSignWeibo($scope.selectedArr, false, '40', function(result) {
                        if (result == 'success') {
                            modalDialog.alertType('直接签发成功', '', 'success', false);
                            $scope.callback();
                        } else {
                            modalDialog.alertType(
                                '该微博直接签发失败！',
                                result.result.detail == '' ? result.result.message : result.result.detail,
                                'error',
                                'confirm',
                                function() {}
                            );
                        }
                    });
                };

                /**
                 * [timeSignForWeibo description] 定时签发
                 * @return {[type]}      [description]
                 */
                $scope.timeSignForWeibo = function() {
                    editingCenterWeiBoService.timeSignWeibo($scope.selectedArr, false, '40', function(result) {
                        if (result == 'success') {
                            modalDialog.alertType('定时签发设置成功', '', 'success', false);
                            $scope.callback();
                        } else {
                            modalDialog.alertType(
                                '该微博定时签发失败！',
                                result.result.detail == '' ? result.result.message : result.result.detail,
                                'error',
                                'confirm',
                                function() {}
                            );
                        }
                    });
                };

                /** *微博操作按钮方法 end***/
            },
        };
    },
]);
